import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { DestroyRef, EnvironmentProviders, inject, PLATFORM_ID, provideAppInitializer } from '@angular/core';

/**
 * Story 87.27 (D5, self pass B3): the site links a web app manifest, so Chrome on Android offers to install it with its
 * own mini-infobar at the foot of a normal tab. Unita shows no install prompt of any kind (D5: installing is the
 * visitor's own step, from Safari's Share menu or the browser's menu), so the browser's `beforeinstallprompt` is
 * cancelled, which keeps that infobar from showing. The browser's own install entry (the address bar's icon, its menu)
 * stays, as accepted. Browser only: the server has no window and no such event.
 */
export function provideNoInstallPrompt(): EnvironmentProviders {
  return provideAppInitializer(() => {
    const win = inject(DOCUMENT).defaultView;
    if (!isPlatformBrowser(inject(PLATFORM_ID)) || !win) return;
    const cancel = (e: Event): void => e.preventDefault();
    win.addEventListener('beforeinstallprompt', cancel);
    inject(DestroyRef).onDestroy(() => win.removeEventListener('beforeinstallprompt', cancel));
  });
}
